"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationLinksLabel = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyMenuConfigurationLinksLabel = (data, multi_selected_links, set_data, t, menu_for_style, selected_style_link) => {
    const parameter_to_modify = (menu_for_style) ? data.style_link : data.links;
    const selected_parameter = (menu_for_style) ? [data.style_link[selected_style_link]] : multi_selected_links.current;
    const linkLabelColor = (param) => {
        let allChecked = true;
        if (selected_parameter.length != 0) {
            switch (param) {
                case 'white':
                    selected_parameter.map(d => {
                        allChecked = (d.text_color == 'white') ? allChecked : false;
                    });
                    break;
                case 'black':
                    selected_parameter.map(d => {
                        allChecked = (d.text_color == 'black') ? allChecked : false;
                    });
                    break;
                case 'color':
                    selected_parameter.map(d => {
                        allChecked = (d.text_color == d.color) ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    const allNodeLabelFontSize = () => {
        let display_size = true;
        let size = 11;
        if (selected_parameter.length != 0) {
            size = selected_parameter[0].label_font_size;
        }
        selected_parameter.map((d) => {
            display_size = (d.label_font_size == size) ? display_size : false;
        });
        return (display_size) ? size : 11;
    };
    const labelPositionVert = (param) => {
        let allChecked = true;
        if (selected_parameter.length != 0) {
            switch (param) {
                case 'beginning':
                    selected_parameter.map(d => {
                        allChecked = (d.label_position == 'beginning') ? allChecked : false;
                    });
                    break;
                case 'middle':
                    selected_parameter.map(d => {
                        allChecked = (d.label_position == 'middle') ? allChecked : false;
                    });
                    break;
                case 'end':
                    selected_parameter.map(d => {
                        allChecked = (d.label_position == 'end') ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    const labelSticktoLinkDisabled = () => {
        let labelSticktoLink = false;
        selected_parameter.map(d => {
            labelSticktoLink = (d.label_on_path) ? true : labelSticktoLink;
        });
        return labelSticktoLink;
    };
    const labelLinkFree = () => {
        let labelLinkFree = false;
        selected_parameter.map(d => {
            labelLinkFree = (d.label_position === 'frozen' && d.orthogonal_label_position === 'frozen') ? true : labelLinkFree;
        });
        return labelLinkFree;
    };
    const labelPositionOrtho = (param) => {
        let allChecked = true;
        if (selected_parameter.length != 0) {
            switch (param) {
                case 'above':
                    selected_parameter.map(d => {
                        allChecked = (d.orthogonal_label_position == 'above') ? allChecked : false;
                    });
                    break;
                case 'middle':
                    selected_parameter.map(d => {
                        allChecked = (d.orthogonal_label_position == 'middle') ? allChecked : false;
                    });
                    break;
                case 'below':
                    selected_parameter.map(d => {
                        allChecked = (d.orthogonal_label_position == 'below') ? allChecked : false;
                    });
                    break;
            }
            return allChecked;
        }
        else {
            return false;
        }
    };
    const labelVisibleChecked = () => {
        let labelVisibleChecked = true;
        selected_parameter.map(d => {
            labelVisibleChecked = (d.label_visible) ? labelVisibleChecked : false;
        });
        return labelVisibleChecked;
    };
    return react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "label", title: t('Flux.label.label') },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.1' },
                        t('Flux.label.tooltips.label'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'switch', checked: labelVisibleChecked(), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.label_visible = evt.target.checked;
                            });
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                react_1.default.createElement(react_bootstrap_1.Form.Label, null, t('Flux.label.vdb')))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.2', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.2' },
                        t('Flux.label.tooltips.len'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'black', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.len'), checked: linkLabelColor('black'), onChange: (evt) => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.text_color = evt.target.value;
                            });
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.3', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.3' },
                        t('Flux.label.tooltips.lb'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'white', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.lb'), checked: linkLabelColor('white'), onChange: (evt) => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.text_color = evt.target.value;
                            });
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.4', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.4' },
                        t('Flux.label.tooltips.lec'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { value: 'same_color', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.lec'), checked: linkLabelColor('color'), onChange: () => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.text_color = d.color;
                            });
                            set_data(Object.assign({}, data));
                        } })))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (labelVisibleChecked()) ? '#555555' : '#DADADA' } }, t('Noeud.labels.tp'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.FormControl, { min: 11, type: 'number', disabled: !labelVisibleChecked(), value: allNodeLabelFontSize(), onChange: evt => {
                        Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => d.label_font_size = +evt.target.value);
                        set_data(Object.assign({}, data));
                    } })),
            react_1.default.createElement(react_bootstrap_1.Col, { style: { color: (labelVisibleChecked()) ? '#555555' : '#DADADA' } }, "px")),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.5', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.5' },
                        t('Flux.label.tooltips.acf'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.acf'), 
                        // disabled={selected_link.current.label_position === 'frozen'}
                        checked: labelSticktoLinkDisabled(), onClick: () => {
                            const val = labelSticktoLinkDisabled();
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.label_on_path = !val;
                                if (!val) {
                                    d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                                    d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                                }
                            });
                            set_data(Object.assign({}, data));
                        } })))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (labelVisibleChecked()) ? '#555555' : '#DADADA' } },
                    t('Flux.label.pl'),
                    ":")),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.6', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.6' },
                        t('Flux.label.tooltips.deb'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'beginning', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.deb'), checked: labelPositionVert('beginning'), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.label_position = evt.target.value;
                                d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                            });
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.7', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.7' },
                        t('Flux.label.tooltips.milieu_h'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'middle', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.milieu'), checked: labelPositionVert('middle'), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.label_position = evt.target.value;
                                d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                            });
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.8', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.8' },
                        t('Flux.label.tooltips.fin'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'end', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.fin'), checked: labelPositionVert('end'), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.label_position = evt.target.value;
                                d.orthogonal_label_position = (d.orthogonal_label_position == 'frozen') ? 'middle' : d.orthogonal_label_position;
                            });
                            set_data(Object.assign({}, data));
                        } })))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: (labelVisibleChecked()) ? '#555555' : '#DADADA' } },
                    t('Flux.label.po'),
                    ":")),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.9', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.9' },
                        t('Flux.label.tooltips.dessous'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'below', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.dessous'), checked: labelPositionOrtho('below'), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.orthogonal_label_position = evt.target.value;
                                d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                            });
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.10', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.10' },
                        t('Flux.label.tooltips.milieu_v'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'middle', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.milieu'), checked: labelPositionOrtho('middle'), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.orthogonal_label_position = evt.target.value;
                                d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                            });
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.11', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.11' },
                        t('Flux.label.tooltips.dessus'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { value: 'above', disabled: !labelVisibleChecked(), type: 'radio', label: t('Flux.label.dessus'), checked: labelPositionOrtho('above'), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.orthogonal_label_position = evt.target.value;
                                d.label_position = (d.label_position == 'frozen') ? 'middle' : d.label_position;
                            });
                            set_data(Object.assign({}, data));
                        } })))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'flux.label.tooltips.12', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'flux.label.tooltips.12' },
                        t('Flux.label.tooltips.pls'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { disabled: !labelVisibleChecked(), type: 'checkbox', label: t('Flux.label.pls'), 
                        // disabled={selected_link.current.label_position === 'frozen'}
                        checked: labelLinkFree(), onChange: evt => {
                            Object.values(parameter_to_modify).filter(f => selected_parameter.map(d => d.idLink).includes(f.idLink)).map(d => {
                                d.label_on_path = (evt.target.checked) ? false : d.label_on_path;
                                d.label_position = (evt.target.checked) ? 'frozen' : 'middle';
                                d.orthogonal_label_position = (evt.target.checked) ? 'frozen' : 'middle';
                            });
                            set_data(Object.assign({}, data));
                        } })))));
};
exports.SankeyMenuConfigurationLinksLabel = SankeyMenuConfigurationLinksLabel;
